import {Component, Input, OnInit} from '@angular/core';
import {VideotextVorhersageBericht} from "../../../../../../../model/vorhersagen/radiobremen-wetterbericht";

@Component({
  selector: 'app-radiobremen-videotext-bericht',
  templateUrl: './radiobremen-videotext-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class RadiobremenVideotextBerichtComponent  {

  @Input() videotextVorhersageBericht: VideotextVorhersageBericht;

}
